import * as React from "react";
import type { SVGProps } from "react";
const BackwardPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M12 13.778v3.995c0 .863-1.02 1.32-1.664.747L3.84 12.747a1 1 0 0 1 0-1.494l6.495-5.774C10.98 4.906 12 5.364 12 6.227v3.995l5.336-4.743C17.98 4.906 19 5.364 19 6.227v11.546c0 .863-1.02 1.32-1.664.747z" clipRule="evenodd" /></svg>;
export default BackwardPanelIcon;